import { Alert, Box, Chip, Stack, Typography } from "@mui/material";
import type { AssistantTaskCard } from "../../../../api/types/assistantTypes";

interface Props {
  taskCard: AssistantTaskCard;
}

const TaskCardContent = ({ taskCard }: Props) => {
  const { name, instruction, schedule, timeZone, endsOn, nextRuns, writeTools, notRunningNotice } = taskCard;
  const scheduleDetails = endsOn ? `${timeZone} · ends ${endsOn}` : timeZone;

  return (
    <Stack spacing={1.5}>
      {name && <Typography variant="subtitle1">{name}</Typography>}
      <Box
        sx={{ borderLeft: 3, borderColor: "primary.main", bgcolor: "background.grey", borderRadius: 1, px: 1.5, py: 1 }}
      >
        <Typography sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{instruction}</Typography>
      </Box>
      <Box>
        <Typography variant="caption" color="textSecondary">
          Schedule
        </Typography>
        <Typography>
          {schedule}{" "}
          <Typography component="span" color="textSecondary">
            · {scheduleDetails}
          </Typography>
        </Typography>
      </Box>
      <Box>
        <Typography variant="caption" color="textSecondary">
          Next runs
        </Typography>
        {notRunningNotice ? (
          <Typography>{notRunningNotice}</Typography>
        ) : (
          <Stack direction="row" spacing={0.5} useFlexGap sx={{ flexWrap: "wrap", mt: 0.5 }}>
            {nextRuns.map((nextRun) => (
              <Chip key={nextRun} label={nextRun} />
            ))}
          </Stack>
        )}
      </Box>
      {writeTools.length > 0 ? (
        <Alert severity="warning">
          <strong>Will make changes without asking you:</strong> {writeTools.join(", ")}
        </Alert>
      ) : (
        <Alert severity="success">Read only — makes no changes</Alert>
      )}
    </Stack>
  );
};

export default TaskCardContent;
